<template>
  <div v-if="$whitelabel.short === 'radiogutscheine'" class="additional-header-content">

    <!--- TODO ADD WHATSAPP  LOGO + LINK-->

    <a href="https://radiogutscheine.de/gutscheine/aktionen/weniger-zahlen_320?newsletter=1" target="_blank"
      rel="noopener noreferrer">
      Newsletter
    </a>
  </div>
</template>

<script>
export default {
  name: 'NavAdditionalHeaderContent',
}
</script>
